'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
var $p;
class $c_Ljava_time_temporal_UnsupportedTemporalTypeException extends $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
export { $c_Ljava_time_temporal_UnsupportedTemporalTypeException as $c_Ljava_time_temporal_UnsupportedTemporalTypeException };
var $d_Ljava_time_temporal_UnsupportedTemporalTypeException = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_UnsupportedTemporalTypeException, "java.time.temporal.UnsupportedTemporalTypeException", ({
  mI: 1,
  bP: 1,
  R: 1,
  Q: 1,
  H: 1,
  a: 1
}));
export { $d_Ljava_time_temporal_UnsupportedTemporalTypeException as $d_Ljava_time_temporal_UnsupportedTemporalTypeException };
